import { Inject, Injectable, InjectionToken } from '@angular/core';
import { CompletionBehaviorTemplate } from '../../entities/completionBehaviorTemplate/completionBehaviorTemplate';
import { CommandInput, CommandTemplate } from '../../entities/commandTemplate/commandTemplate';
import { ApolloService } from '../apollo.service';
import * as fromGraphQl from './graphql';

export interface Flow {
  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput, completionCallback: () => void,
    reloadable?: Reloadable): any;
}

export interface CompletionBehavior {
  executeCompletionBehavior(hasCommands: HasCommands, CompletionBehaviorTemplate: CompletionBehaviorTemplate, reloadable?: Reloadable): any;
}

export interface Reloadable {
  reload(): void;
}

export const FLOW_MAP = new InjectionToken<Map<string, Flow>>('FLOW_MAP');
export const ADDITIONAL_FLOWS = new InjectionToken<Map<string, Flow>>('ADDITIONAL_FLOWS');
export const COMPLETION_BEHAVIOR_MAP = new InjectionToken<Map<string, CompletionBehavior>>('COMPLETION_BEHAVIOR_MAP');
export const ADDITIONAL_COMPLETION_BEHAVIORS = new InjectionToken<Map<string, CompletionBehavior>>('ADDITIONAL_COMPLETION_BEHAVIORS');

@Injectable({
  providedIn: 'root'
})
export class CommandService {

  constructor(
    private apolloService: ApolloService,
    @Inject(FLOW_MAP) private strategies: Map<string, Flow>,
    @Inject(COMPLETION_BEHAVIOR_MAP) private completionBehaviors: Map<string, CompletionBehavior>,
  ) { }

  public execute(hasCommands: HasCommands, commandTemplate: CommandTemplate, reloadable?: Reloadable) {

    console.log("Executing command: ", commandTemplate.name);
    let flowName;
    if(commandTemplate.flow?.name === "customFlow" && commandTemplate.flow?.settings?.customFlowName){
      flowName = commandTemplate.flow?.settings?.customFlowName;
    } else {
      flowName = commandTemplate.flow?.name;
    }

    const flow = this.strategies.get(flowName);

    let commandInput = new CommandInput();
    commandInput.name = commandTemplate.name;
    if(commandTemplate.parameters){
      commandTemplate.parameters.map( (parameter) => {
        if(parameter.value){
          commandInput.addParameter(parameter.name, parameter.value);
        }
      });
    }

    let completionBehaviorName;
    if(commandTemplate.flow.completionBehavior?.name === "customCompletionBehavior" && commandTemplate.flow.completionBehavior?.settings?.customCompletionBehaviorName){
      completionBehaviorName = commandTemplate?.flow.completionBehavior?.settings?.customCompletionBehaviorName;
    } else {
      completionBehaviorName = commandTemplate?.flow?.completionBehavior?.name;
    }
    const completionBehavior = this.completionBehaviors.get(completionBehaviorName);

    flow?.executeFlow(this, hasCommands, commandTemplate, commandInput, () => {
      if(completionBehavior) {
        completionBehavior.executeCompletionBehavior(hasCommands, commandTemplate.flow?.completionBehavior, reloadable);
      }
    }, reloadable);

  }

  public sendCommand(commandInput: CommandInput, completionBehavior: any) {
    this.apolloService.mutateAndExecute(
      fromGraphQl.EXECUTE_COMMAND_MUTATION,
      {
        commandInput,
      },
      completionBehavior
    );
  }

  public getCommandByCommandInput(commandInput: CommandInput) {
    return this.apolloService.query<fromGraphQl.getCommandByCommandInputResponse>(
      fromGraphQl.GET_COMMAND_BY_COMMAND_INPUT_QUERY,
      {
        commandInput
      }
    );
  }
}

export interface HasCommands {
  getEntityId(): string;
  getCollectionRoute(): string;
  getEntityType(): string;
}
